<template>
    <div>
        <v-layout class="text-h6 mb-3">
            {{ chargePeriod }}'s Balance for Unit {{ balance.unit_name }}
        </v-layout>
        <v-layout column class="mb-4 subheading">
            <div v-if="paidThisMonth">
                No balance due on this unit for the current month.
            </div>
            <div v-else>
              <div v-if="chargesWithBalance.length">
                <div
                  v-for="(charge, i) in chargesWithBalance"
                  :key="i"
                >
                <template v-if="charge.type === 'rent'">
                  <v-layout>
                      <v-flex xs4>{{ `${getMonth(charge)} ${formatItem(charge)}` }}:</v-flex>
                      <v-flex xs3 class="text-sm-right">${{ parseFloat(charge.amount).toFixed(2) }}</v-flex>
                  </v-layout>
                  <v-layout v-if="charge.tax > 0">
                    <v-flex xs4>{{ getMonth(charge) }} Rent Tax:</v-flex>
                    <v-flex xs3 class="text-sm-right">${{ parseFloat(charge.tax).toFixed(2) }}</v-flex>
                  </v-layout>
                </template>
                <template v-else>
                  <v-layout>
                      <v-flex xs4>{{ formatItem(charge) }}:</v-flex>
                      <v-flex xs3 class="text-sm-right">${{ parseFloat(charge.total).toFixed(2) }}</v-flex>
                  </v-layout>
                </template>
                </div>
              </div>
              <v-flex xs7 class="my-2">
                  <v-divider />
              </v-flex>
              <v-layout class="text-h6">
                  <v-flex xs4>Total:</v-flex>
                  <v-flex xs3 class="text-sm-right">${{ balance.total_with_tax.toFixed(2) }}</v-flex>
              </v-layout>
            </div>
        </v-layout>
    </div>
</template>

<script>
import moment from "moment";

/* eslint-disable no-return-assign */
export default {
  props: {
    balance: {
      type: Object
    },
    chargePeriod: {
      type: String
    }
  },

  methods: {
    formatItem(item) {
      return item.type === "tpp" ? "TPP" : item.description;
    },
    getMonth(item) {
      return moment(item.start_date).format("MMM");
    }
  },

  computed: {
    chargesWithBalance() {
      return this.balance.charges.filter(item => item.total);
    },

    paidThisMonth() {
      if (this.chargePeriod === "This Month") {
        return !this.balance.total_with_tax;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>

</style>
